export const PageCreatedPolicies = () => {

  return (
    <>
      <h1>Created policies</h1>
    </>
  );
};

